module.exports = __webpack_public_path__ + "static/media/inactive.5f0f80f3.svg";